import { takeEvery } from 'redux-saga/effects';
import { GET_LOGOUT, POST_AUTHENTICATE } from './login.action';
import { getLogoutSaga, postAuthenticateSaga } from './login.saga';

export const loginSaga = [
  takeEvery(POST_AUTHENTICATE, postAuthenticateSaga),
  takeEvery(GET_LOGOUT, getLogoutSaga)
];
